import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

export interface ProjectFilterParams {
  page: number;
  limit: number;
  search?: string;
  is_archived?: boolean | string;
}

export const fetchProjectsQueryFn = async (
  filters: ProjectFilterParams,
  signal?: AbortSignal
) => {
  const response = await axiosInstance.get("/projects", {
    params: filters,
    signal,
  });

  const result = responseDataFormate(response.data);

  if (result?.success) {
    return result.data;
  } else {
    throw new Error(result?.message || "Failed to fetch Projects");
  }
};

interface RenameProjectParams {
  payload: { id: string; new_project_no: string };
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const renameProjectAPI =
  ({ payload, onSuccess, onError }: RenameProjectParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put("/projects", null, { params: payload });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Project renamed successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to rename project");
        onError?.();
      }
    } catch (error: any) {
      console.error("Rename Project error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage || "Something went wrong");
    }
  };

interface DeleteProjectParams {
  payload: { project_no: string };
  onSuccess: (data?: any) => void;
  onError: () => void;
}

export const deleteProjectAPI =
  ({ payload, onSuccess, onError }: DeleteProjectParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete("/projects", { params: payload });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Project deleted successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to delete project");
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete Project error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage || "Something went wrong");
    }
  };

export interface SubFolderFilterParams {
  project_no: string;
  rev_no?: string;
  is_archived?: boolean;
}

interface GetSubFolderDetailsParams {
  filters: SubFolderFilterParams;
  onSuccess?: (data: any) => void;
  onError?: () => void;
  signal?: AbortSignal;
}

export const getSubFolderDetailsAPI =
  ({ filters, onSuccess, onError, signal }: GetSubFolderDetailsParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get("/projects/sub-folder", {
        params: filters,
        signal,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      if (error.code === "ERR_CANCELED" || error.name === "AbortError") return;
      console.error("Get Sub-Folder Details Error:", error);
      message.error(error?.response?.data?.message);
      onError?.();
    }
  };

  interface ArchiveProjectParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const archiveProjectAPI =
  ({ payload, onSuccess, onError }: ArchiveProjectParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put("/projects/archive", payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Archive Project error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage || "Something went wrong");
    }
  };
